module.exports = __webpack_public_path__ + "static/5-a7788ade101debb1c995280e2be5b771.jpg";